import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { useNavigate } from "react-router-dom";
import "./careers.css";
import bannerImage from "../img/img3.jpg";
import SEOHead from '../components/SEOHead';
import Footer from '../components/Footer';
import LazyImage from '../components/LazyImage';


const positions = [

    {
        id: "digital-marketing-intern",
        title: "Graduate Internship",
        location: "Coimbatore",
        type: "Intern",
        department: "Any Department",
        experience: "Fresher",
        description: "Support digital marketing initiatives through content, market research...",
    }, 
    {
        id: "business-development-associate",
        title: "Business Development Associate",
        location: "Coimbatore",
        type: "Full-time",
        department: "Any Department",
        experience: "Fresher",
        description: "Support business growth through market research, client outreach...",
    }, 
    {
        id: "student-intern",
        title: "Digital Intern",
        location: "Coimbatore",
        type: "Intern",
        department: "Any Department",
        experience: "Fresher",
        description: "Work on cutting-edge digital platforms and scalable systems...",
    },
  
    {
        id: "electronics-engineer",
        title: "Electronic Design Engineer",
        location: "Coimbatore",
        type: "Full-time",
        department: "Hardware",
        experience: "2+ Years",
        description: "Involves the end-to-end development of electronic systems, with a...",
    },

    {
        id: "project-admin",
        title: "Project Administrator",
        location: "Coimbatore",
        type: "Full-time",
        department: "Software",
        experience: "0 - 6 months",
        description: "Assist project managers with project planning and maintaining timelines..",
    },

    {
        id: "innovation-engineering-graduate-pathway",
        title: "Innovation & Engineering Graduate Pathway",
        location: "Coimbatore",
        type: "Full/Part-time",
        department: "Technical Training",
        experience: "Fresher",
        description: "Exposure to emerging technologies and consulting practices...",
    },
       {
        id: "electronics-intern",
        title: "Electronics Intern",
        location: "Coimbatore",
        type: "Intern",
        department: "Electronics",
        experience: "Fresher",
        description: "Hands-on experience in electronics product development...",
    }, 
       {
        id: "ai-intern",
        title: "AI Data Engineer Intern",
        location: "Coimbatore",
        type: "Intern",
        department: "Machine Learning",
        experience: "Fresher",
        description: "Collaborate with our AI/ML team to build data ingestion workflows...",
    }, 
        // {
    //     id: "fsd-intern",
    //     title: "Full-Stack Developer (MERN)",
    //     location: "Coimbatore",
    //     type: "Full-time",
    //     department: "Software",
    //     experience: "0 - 1 year",
    //     description: "Collaborate with senior developers to write efficient, and reusable code...",
    // },
    // {
    //     id: "ml-intern",
    //     title: "Backend Engineer",
    //     location: "Coimbatore",
    //     type: "Full-time",
    //     department: "Software",
    //     experience: "0 - 1 year",
    //     description: "Assist in designing and developing backend services and APIs for...",
    // },
        // {
    //     id: "firmware-dev",
    //     title: "Firmware Developer – Medical Devices",
    //     location: "Coimbatore",
    //     type: "Full-time",
    //     department: "Hardware",
    //     experience: "0 - 1 year",
    //     description: "Will design and implement embedded software for medical devices...",
    // },
    // {
    //     id: "junior-electronics-engineer",
    //     title: "Junior Electronics Engineer",
    //     location: "Coimbatore",
    //     type: "Full-time",
    //     department: "Hardware",
    //     experience: "0 - 1 year",
    //     description: "Support senior engineers in designing and testing electronic circuits...",
    // },
    // {
    //     id: "seo-analyst",
    //     title: "SEO Analyst",
    //     location: "Coimbatore",
    //     type: "Full-time",
    //     department: "Software",
    //     experience: "0 - 1 year",
    //     description: " Perform on-page SEO optimisation, including meta tags...",
    // }, 
];

const Careers = () => {
    const [showScrollTop, setShowScrollTop] = React.useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setShowScrollTop(window.scrollY > 300);
        };
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const navigate = useNavigate();

    const handleCardClick = (id) => {
        sessionStorage.setItem("scrollPosition", window.scrollY);
        navigate(`/careers/${id}`);
    };

    useEffect(() => {
        const scrollPosition = sessionStorage.getItem("scrollPosition");
        if (scrollPosition) {
            window.scrollTo(0, parseInt(scrollPosition, 10));
            sessionStorage.removeItem("scrollPosition");
        }
    }, []);
    useEffect(() => {
        AOS.init({
            duration: 1500, // Animation duration in ms
            once: true,     // Only animate once
        });
    }, []);


    return (
        <>
            <SEOHead 
                title="Careers | AK Consultants"
                description="Join AK Consultants' growing team! Explore exciting career opportunities in AI, software development, electronics engineering, biomedical engineering, and more in Coimbatore."
            />
            <div className="careers-container">
                <div className="careers-banner" data-aos="fade-up">
                    <LazyImage src={bannerImage} alt="Careers at AK Consultants" />
                    <div className="banner-title">Careers</div>
                </div>

                <section className="why-join" data-aos="fade-up">
                    <h2>Why Join Us</h2>
                    <p>
                        At AK Consultants, we’re building smart, scalable software solutions that power real-world impact.
                        As a product and service-driven startup, we blend innovation, speed, and purpose to tackle complex challenges with clarity.
                        You'll work alongside bold thinkers, passionate builders, and a team that turns great ideas into world-class platforms.
                        We foster ownership, creativity, and a growth mindset. Because your voice and vision matter here.
                    </p>
                </section>

                <section className="open-positions-section" data-aos="fade-up">
                    <div className="open-positions-container" >
                        <h2>Open Positions</h2>

                        {/* INLINE FLEX GRID - 3 cards per row with centered last row */}
                        <div
                            className="positions-list jobs-grid"
                            data-aos="fade-up"
                            style={{
                                display: "flex",
                                flexWrap: "wrap",
                                justifyContent: "center",   // centers items and the last row
                                gap: "20px",
                                maxWidth: "1250px",         // constrain for 3 cards per row (3 * 385px + gaps)
                                margin: "0 auto",
                                padding: "0 10px",
                                boxSizing: "border-box"
                            }}
                        >
                            {positions.map((job) => (
                                <div
                                    className="job-card"
                                    key={job.id}
                                    onClick={() => handleCardClick(job.id)}
                                    style={{
                                        flex: "0 0 385px",     // fixed base width (prevents stretching)
                                        maxWidth: "385px",
                                        width: "100%",
                                        boxSizing: "border-box",
                                    }}
                                >
                                    <div className="job-header">
                                        <div className="job-title-container">
                                            <h3>{job.title}</h3>
                                        </div>
                                        <div className="job-badge-container">
                                            <span className="badge">{job.type}</span>
                                        </div>
                                    </div>
                                    <div className="job-meta">
                                        <span><strong>Department:</strong> {job.department}</span>
                                        <span><strong>Experience:</strong> {job.experience}</span>
                                        <span><strong>Location:</strong> {job.location}</span>
                                        <p>{job.description}</p>
                                    </div>
                                    <span className="apply-button">See Details</span>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                <section className="benefits" data-aos="fade-up">
                    <h2>Perks & Benefits</h2>
                    <ul className="benefit-grid" data-aos="fade-up">
                        <li><i className="fa-solid fa-heart-pulse"></i> Health & Wellness Programs</li>
                        <li><i className="fa-solid fa-clock"></i> Flexible Work Arrangements</li>
                        <li><i className="fa-solid fa-graduation-cap"></i> Learning & Development Support</li>
                        <li><i className="fa-solid fa-user-group"></i> Inclusive & Collaborative Culture</li>
                        <li><i className="fa-solid fa-money-bill-wave"></i> Stock Options & Bonuses</li>
                        <li><i className="fa-solid fa-lightbulb"></i> Innovation-Driven Projects</li>
                        <li><i className="fa-solid fa-handshake-angle"></i> Mentorship & Career Guidance</li>
                        <li><i className="fa-solid fa-building"></i> Modern & Well-Equipped Workspace</li>
                    </ul>
                </section>

                <div className="careers-footer-spacer"></div>

                <section className="cta-banner" data-aos="fade-up">
                    <div className="cta-banner-circle cta-circle-large-left"></div>
                    <div className="cta-banner-circle cta-circle-small-left"></div>
                    <div className="cta-banner-content">
                        <h2>Ready to Make an Impact?</h2>
                        <p>We're always looking for passionate individuals, for any related queries reach out.</p>
                        <a href="mailto:info@ak-tech.in" className="contact-btn" data-aos="fade-up">Get in Touch</a>
                    </div>
                    <div className="cta-banner-circle cta-circle-large-right"></div>
                    <div className="cta-banner-circle cta-circle-small-right"></div>
                </section>

                <div style={{ marginTop: '80px' }}>
                    <Footer />
                </div>
                {showScrollTop && (
                    <button className="scroll-to-top" onClick={scrollToTop}>
                        <i className="fa fa-arrow-up" style={{ position: 'relative', right: '1.5px' }}></i>
                    </button>
                )}
            </div>
        </>
    );
};

export default Careers;
